<template>
    <div id="kioskCheckinForm" class="card mb-3">
        <div class="card-body">
            <h6 class="card-title font-weight-bold"><i class="fas fa-tablet"></i> Kiosk Check-in</h6>
            <div class="form-group">
                <label>Status</label>
                <select v-model="state" class="form-control">
                    <option value="open">Open</option>
                    <option value="closed">Closed</option>
                </select>
            </div>
            <div class="form-group">
                <label>Show Closed Message</label>
                <select v-model="showClosedMessage" class="form-control">
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                </select>
            </div>
            <div class="form-group">
                <label>Closed Message (Optional)</label>
                <textarea v-model="closedMessage" class="form-control"
                    placeholder="Please provide a reason and/or message for the kiosk check-in shutdown.."></textarea>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'kiosk-checkin-settings-form',
    props: {
        settings: {
            required: true
        }
    },
    data() {
        return {
            closedMessage: '',
            showClosedMessage: '1',
            state: 'open',
        }
    },
    methods: {
        getSettings() {
            return {
                closedMessage: this.closedMessage,
                showClosedMessage: this.showClosedMessage,
                state: this.state,
                type: 'kiosk'
            }
        },
        setSettings() {
            let settings = this.settings.types || [];
            let system = {};

            if (settings.length > 0) {
                settings.forEach(setting => {
                    system = setting.type && setting.type == "kiosk" ? setting : system;
                });
            }

            this.closedMessage = system.closedMessage ? system.closedMessage : this.closedMessage;
            this.showClosedMessage = system.showClosedMessage ? system.showClosedMessage : this.showClosedMessage;
            this.state = system.state ? system.state : this.state;
        }
    }
}
</script>